export default {"src":"/_next/static/media/PizzaDay_small.38fe5e96.svg","height":193,"width":192,"blurWidth":0,"blurHeight":0};